<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="slide-x-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn rounded v-bind="attrs" v-on="on" icon>
        <v-badge
          :content="notifications.length"
          :value="notifications.length"
          color="error"
          overlap
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-card min-width="400">
      <v-tabs grow>
        <v-tab>
          Alerts
          <v-badge
            :content="notifications.length"
            :value="notifications.length"
            color="warning"
            overlap
          >
            <v-icon right>mdi-bell</v-icon>
          </v-badge>
        </v-tab>

        <v-tab-item>
          <v-list dense>
            <v-list-item-group>
              <v-list-item
                two-line
                v-for="(notification, i) in notifications"
                :key="i"
                :to="{ name: notification.action }"
              >
                <v-list-item-action>
                  <v-icon color="primary">mdi-alert-circle-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ notification.title }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ notification.message }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-menu>
</template>

<script>
import DateMixin from "../../../mixins/DateMixin";
import SetupMixin from "../../setup/SetupMixin";

export default {
  name: "Notification",
  mixins: [DateMixin, SetupMixin],
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    statusdata: undefined,
  }),

  computed: {
    notifications() {
      return this.$store.getters["Dashboard/notifications"];
    },
  },
};
</script>

<style scoped></style>
